
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import Icon from 'vux/src/components/icon/index.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'

import {mapGetters} from 'vuex'
import { Dialog } from 'vant';
export default{
computed: {

headShow() {
return this.$store.getters.headShow;
},
loading() {
return this.$store.getters.loading;
},
footerShow() {
return this.$store.getters.footerShow;
},
pageTitle() {



return  this.$route.query.titles;
},
paginatedData() {
console.log("处理分页")
var start = (this.currentPage - 1) * this.pageSize;
console.log(start)
var end = start + this.pageSize;
console.log(end)
return this.totalData.slice(start, end);
},

},
components: {
Tabbar,
TabbarItem,
XHeader,
Loading,
ViewBox,
Icon
},
data(){
return{

likedfile:[],
transmitfile:[],
watchingfile:[],
commentfile:[],
reportfile:[],
gzfile:[],
tpfile:[],
totalData: [],
uploader: [],

currentPage: 1,

pageSize: 4,


filelist:[],
filelist1:[],
filelist2:[],
filelist3:[],
filelist4:[],
filelist5:[],
filelist6:[],

imgfile:[],
imgfile1:[],
imgfile2:[],
imgfile3:[],
imgfile4:[],
imgfile5:[],
pageCount: 0,
searchValue: '',
infoShow: false,
infoShow1: false,
sfxs:1,
statuss:'',
urls:[],
imgszs:[],
tanchukuang:[],
test:{
"height": '',
"overflow": "scroll"
}
}
},
mounted(){


console.log("钩子函数")
console.log(sessionStorage.getItem("pageTitle"))
console.log(localStorage.getItem("wxid"))


if(  this.$route.query.titles === "待完任务"){
this.statuss = "未提交未审核"
this.sfxs = 0
}else if(this.$route.query.titles === "已完任务"){
this.statuss = "已提交已通过"
this.sfxs = 1

}else if(this.$route.query.titles === "超期任务"){
this.statuss = "超期"
this.sfxs = 3

}else if(this.$route.query.titles === "退回任务"){
this.statuss = "已提交未通过"
this.sfxs = 2

}else if(this.$route.query.titles === "审核任务"){
this.statuss = "已提交未审核"
this.sfxs = 1

}



this.doPage(localStorage.getItem("wxid"))
this.$store.commit('UPDATE_PAGE_TITLE',this.$route.query.titles)

},
methods: {
afterRead(files, detail) {
files.forEach(element => {
element.rate = 10; 
setTimeout(() => {
element.status = null;
}, 2000);
});
},
dianzan(item){
console.log("点赞")
if(_.isEmpty(item)){
console.log("点赞111")
}else{
console.log("点赞222")
return item.includes('点赞')
}
},
zhuangfa(item){
console.log("转发")
if(_.isEmpty(item)){

}else{

return item.includes('转发')
}
},
zaikan(item){
console.log("在看")
if(_.isEmpty(item)){

}else{

return item.includes('在看')
}
},
pinglun(item){
console.log("评论")
if(_.isEmpty(item)){

}else{

return item.includes('评论')
}
},
jubao(item){
console.log("举报")
if(_.isEmpty(item)){

}else{

return item.includes('举报')
}
},
guanzhu(item){
console.log("关注")
if(_.isEmpty(item)){

}else{

return item.includes('关注')
}
},
toupiao(item){
console.log("投票")
if(_.isEmpty(item)){

}else{

return item.includes('投票')
}
},
tiao(title,id,demand,bumen,urls){



console.log(title)
this.$router.push({ name: 'Ttask', params: { titles:title,id:id,demand:demand,bumen:bumen,urls:urls}});
},
open(item){
console.log("进入跳转")
var externalUrl =  this.tanchukuang.url;
console.log(item)

window.location.href = item
},
getimg(img){

var imgs = img.split(',')

return this.$httpUrl2+imgs[0]
},
getimg2(img){
console.log(img)
return this.$httpUrl2+img
},
listDes(item){
console.log(item)
this.tanchukuang = item

var strArr = item.url

console.log(112233)
console.log(strArr)
console.log(strArr.split(','))
console.log(112233)
strArr.substring(0,strArr.length-1)


this.urls =  strArr.substring(0,strArr.length-1).split(',')


this.test.height = (document.body.clientHeight-280)+'px'
if( this.sfxs === 0){
console.log("我进来了1112233")
console.log(item.demand)
if(item.demand.includes('点赞')){
console.log("我进来了1112233点赞")
this.imgfile =  item.example_liked_img.split(',')
this.imgfile.forEach((item,index)=>{
let newarr = this.$httpUrl +item
this.$set(this.filelist, index, {url:newarr});
})
}
if(item.demand.includes('在看')){
console.log("我进来了1112233在看")
this.imgfile1 =  item.example_watching_img.split(',')
this.imgfile1.forEach((item,index)=>{
let newarr1 = this.$httpUrl +item
this.$set(this.filelist1, index, {url:newarr1});
})
}
if(item.demand.includes('转发')){
console.log("我进来了1112233转发")
this.imgfile2 =  item.example_transmit_img.split(',')
this.imgfile2.forEach((item,index)=>{
let newarr2 = this.$httpUrl +item
this.$set(this.filelist2, index, {url:newarr2});
})
}
if(item.demand.includes('评论')){
console.log("我进来了1112233评论")
this.imgfile3 =  item.example_comment_img.split(',')
this.imgfile3.forEach((item,index)=>{
let newarr3 = this.$httpUrl +item
this.$set(this.filelist3, index, {url:newarr3});
})
}
if(item.demand.includes('举报')){
console.log("我进来了1112233举报")
this.imgfile3 =  item.example_report_img.split(',')
this.imgfile3.forEach((item,index)=>{
let newarr3 = this.$httpUrl +item
this.$set(this.filelist4, index, {url:newarr3});
})
}
if(item.demand.includes('关注')){
console.log("我进来了1112233关注")
this.imgfile4 =  item.example_gz_img.split(',')
this.imgfile4.forEach((item,index)=>{
let newarr3 = this.$httpUrl +item
this.$set(this.filelist5, index, {url:newarr3});
})
}
if(item.demand.includes('投票')){
console.log("我进来了1112233投票")
this.imgfile5 =  item.example_tp_img.split(',')
this.imgfile5.forEach((item,index)=>{
let newarr3 = this.$httpUrl +item
this.$set(this.filelist6, index, {url:newarr3});
})
}
this.infoShow = true
}else if(this.sfxs === 1 || this.sfxs === 2){
console.log(this.sfxs,"this.sfxs")



if(item.demand.includes('点赞')){
console.log("我进来了1112233点赞")
this.imgfile =  item.likedfile.split(',')
this.imgfile.forEach((item,index)=>{
console.log(item,"item")
let newlikedfile = this.$httpUrl2+item

this.$set(this.likedfile, index, {url:newlikedfile});
})
}
if(item.demand.includes('在看')){
console.log("我进来了1112233在看")
this.imgfile1 =  item.watchingfile.split(',')
this.imgfile1.forEach((item,index)=>{


let newwatchingfile = this.$httpUrl2+item
this.$set(this.watchingfile, index, {url:newwatchingfile});
})
}
if(item.demand.includes('转发')){
console.log("我进来了1112233转发")
this.imgfile2 =  item.transmitfile.split(',')
this.imgfile2.forEach((item,index)=>{

let newtransmitfile = this.$httpUrl2+item
this.$set(this.transmitfile, index, {url:newtransmitfile});

})
}
if(item.demand.includes('评论')){
console.log("我进来了1112233评论")
this.imgfile3 =  item.commentfile.split(',')
this.imgfile3.forEach((item,index)=>{

let newcommentfile = this.$httpUrl2+item
this.$set(this.commentfile, index, {url:newcommentfile});
})
}
if(item.demand.includes('举报')){
console.log("我进来了1112233举报")
this.imgfile3 =  item.reportfile.split(',')
this.imgfile3.forEach((item,index)=>{

let newcommentfile = this.$httpUrl2+item
this.$set(this.reportfile, index, {url:newcommentfile});
})
}
if(item.demand.includes('关注')){
console.log("我进来了1112233关注1")
this.imgfile4 =  item.gzfile.split(',')
this.imgfile4.forEach((item,index)=>{
let newcommentfile = this.$httpUrl2+item
this.$set(this.gzfile, index, {url:newcommentfile});
})
}
if(item.demand.includes('投票')){
console.log("我进来了1112233投票1")
this.imgfile5 =  item.tpfile.split(',')
this.imgfile5.forEach((item,index)=>{
let newcommentfile = this.$httpUrl2+item
console.log(newcommentfile,"照片地址")
this.$set(this.tpfile, index, {url:newcommentfile});
})
}















this.uploader = item.commentfile
this.infoShow1 = true
}

},


fetchData2(){
console.log("长度")
console.log(this.totalData.length )
},
fetchData() {
console.log("处理分页2")


this.totalData = Array.from({ length: 100 }, (_, index) => ({
title: `任务标题${index + 1}`,
time: `2024-07-2${index + 1} 12:00:00`,
}));


console.log(this.totalData.length, 'total')
console.log("长度：")
this.pageCount = Math.ceil(this.totalData.length / this.pageSize);
},
handlePageChange(page) {

this.currentPage = page;
},

doPage(wxid) {
this.$axios.get(this.$httpUrl + '/daren/personwork/list?ryid='+wxid+'&status='+ this.statuss+'&authority=普通员工' ,).then(res => res.data).then(res => {
console.log(res)
this.totalData = res.rows

console.log("长度")
console.log(this.totalData.length )
this.pageCount = Math.ceil(this.totalData.length / this.pageSize);


})
},
},
}



// WEBPACK FOOTER //
// ./src/views/Dtask.vue